import React from 'react'
import PropTypes from 'prop-types'

const Check = ({ color = 'white', className }) => {
    return (
        <svg
            className={className}
            width="10"
            height="7"
            viewBox="0 0 10 7"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.20643 0.292787C9.3939 0.480314 9.49922 0.734622 9.49922 0.999786C9.49922 1.26495 9.3939 1.51926 9.20643 1.70679L4.20643 6.70679C4.0189 6.89426 3.76459 6.99957 3.49943 6.99957C3.23427 6.99957 2.97996 6.89426 2.79243 6.70679L0.792431 4.70679C0.610272 4.51818 0.509478 4.26558 0.511757 4.00339C0.514035 3.74119 0.619204 3.49038 0.804612 3.30497C0.99002 3.11956 1.24083 3.01439 1.50303 3.01211C1.76523 3.00983 2.01783 3.11063 2.20643 3.29279L3.49943 4.58579L7.79243 0.292787C7.97996 0.105316 8.23427 0 8.49943 0C8.7646 0 9.0189 0.105316 9.20643 0.292787Z"
                fill={color}
            />
        </svg>
    )
}

Check.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
}

export default Check
